import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_CNTY_CD_INFO } from "@/tz/go/egaz/osci/ptl/cd/cntycd/services/OsciCntyCdService";

/*
 * Region Code Registration
 * !== 지역 코드 등록 ==!
 */
export const OSCI0109010S = () => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "OSC0091" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        cntyCdInfo: useForm({
            defaultSchema: SF_CNTY_CD_INFO,
        }),
    };

    const fetch = {
        insertCntyCdInfo: useFetch({
            api: (data: any) => APIS.insertCntyCdInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(`${URLS.osci0109009q}?menuId=${menuId}`);
                    },
                });
            },
            onError: (data) => {
                modal.openModal({ content: data.response.data.errorMessage }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                // toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.cntyCdInfo.reset();
        },
        onListBtnClick: () => {
            navigate(`${URLS.osci0109009q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.cntyCdInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.cntyCdInfo.handleSubmit(
                () => {
                    const data = form.cntyCdInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertCntyCdInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.cntyCdInfo.errors), form.cntyCdInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.cntyCdInfo.clearErrors();
            form.cntyCdInfo.resetSchema();
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.dgt3CntyCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.dgt3NumCntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyEngAbrtNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmEn} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmTz} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
